export const blogPosts = [
  {
    id: 9,
    slug: 'london-travel-tips-overseas-pakistanis-families',
    title: 'Essential London Travel Tips for Overseas Pakistani Families Visiting the UK',
    excerpt: 'Your complete guide to navigating London on a budget, finding halal food, family-friendly attractions, and budget hotels near Pakistani communities.',
    category: 'London Guide',
    image: 'https://public.readdy.ai/ai/img_res/63abea566d1912550a408d3f9c2cc4fb.jpg',
    author: 'Sarah Thompson',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20friendly%20British%20woman%2C%20warm%20smile%2C%20neutral%20background%2C%20high%20quality%20portrait%20photography&width=100&height=100&seq=author-sarah-001&orientation=squarish',
    date: '18 Jan 2025',
    readTime: '15 min read',
    featured: true,
  },
  {
    id: 1,
    slug: 'complete-guide-umrah-first-timers',
    title: 'Complete Guide to Umrah for First-Time Pilgrims',
    excerpt: 'Everything you need to know before embarking on your spiritual journey to Makkah and Madinah, from preparation to rituals.',
    category: 'Spiritual Travel',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20interior%20of%20Masjid%20al-Haram%20in%20Makkah%20with%20pilgrims%20performing%20tawaf%20around%20the%20Kaaba%2C%20golden%20lighting%2C%20spiritual%20atmosphere%2C%20architectural%20details%2C%20peaceful%20and%20serene%2C%20professional%20photography%2C%20warm%20tones&width=800&height=500&seq=blog-umrah-guide-001&orientation=landscape',
    author: 'Ahmed Hassan',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20middle%20eastern%20man%20in%20business%20attire%2C%20friendly%20smile%2C%20neutral%20background%2C%20high%20quality%20portrait%20photography&width=100&height=100&seq=author-ahmed-001&orientation=squarish',
    date: '15 Jan 2025',
    readTime: '12 min read',
    featured: true,
  },
  {
    id: 2,
    slug: 'hidden-gems-istanbul-turkey',
    title: 'Hidden Gems of Istanbul: Beyond the Tourist Trail',
    excerpt: 'Discover the secret neighborhoods, local eateries, and authentic experiences that most visitors miss in this magical city.',
    category: 'Destination Guide',
    image: 'https://readdy.ai/api/search-image?query=Charming%20narrow%20street%20in%20Istanbul%20old%20town%20with%20traditional%20Ottoman%20architecture%2C%20colorful%20buildings%2C%20hanging%20lanterns%2C%20cobblestone%20path%2C%20morning%20light%2C%20authentic%20Turkish%20atmosphere%2C%20travel%20photography&width=800&height=500&seq=blog-istanbul-gems-002&orientation=landscape',
    author: 'Fatima Al-Rashid',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20elegant%20woman%20wearing%20hijab%2C%20warm%20smile%2C%20neutral%20background%2C%20high%20quality%20portrait%20photography&width=100&height=100&seq=author-fatima-001&orientation=squarish',
    date: '12 Jan 2025',
    readTime: '8 min read',
    featured: true,
  },
  {
    id: 3,
    slug: 'family-travel-tips-middle-east',
    title: 'Travelling with Children in the Middle East: Essential Tips',
    excerpt: 'Practical advice for families planning trips to Saudi Arabia, UAE, and Turkey with kids of all ages.',
    category: 'Family Travel',
    image: 'https://readdy.ai/api/search-image?query=Happy%20family%20with%20children%20walking%20through%20beautiful%20Middle%20Eastern%20marketplace%2C%20traditional%20architecture%2C%20warm%20sunset%20lighting%2C%20joyful%20atmosphere%2C%20travel%20lifestyle%20photography%2C%20authentic%20cultural%20experience&width=800&height=500&seq=blog-family-travel-003&orientation=landscape',
    author: 'Sarah Thompson',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20friendly%20British%20woman%2C%20warm%20smile%2C%20neutral%20background%2C%20high%20quality%20portrait%20photography&width=100&height=100&seq=author-sarah-001&orientation=squarish',
    date: '10 Jan 2025',
    readTime: '10 min read',
    featured: false,
  },
  {
    id: 4,
    slug: 'halal-food-guide-dubai',
    title: 'The Ultimate Halal Food Guide to Dubai',
    excerpt: 'From street food to fine dining, explore the best halal culinary experiences Dubai has to offer.',
    category: 'Food & Culture',
    image: 'https://readdy.ai/api/search-image?query=Delicious%20spread%20of%20traditional%20Middle%20Eastern%20food%20on%20elegant%20table%2C%20hummus%2C%20kebabs%2C%20fresh%20bread%2C%20colorful%20dishes%2C%20restaurant%20setting%2C%20food%20photography%2C%20warm%20lighting%2C%20appetizing%20presentation&width=800&height=500&seq=blog-halal-food-004&orientation=landscape',
    author: 'Omar Khalil',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Arab%20man%20with%20beard%2C%20friendly%20expression%2C%20neutral%20background%2C%20high%20quality%20portrait%20photography&width=100&height=100&seq=author-omar-001&orientation=squarish',
    date: '8 Jan 2025',
    readTime: '7 min read',
    featured: false,
  },
  {
    id: 5,
    slug: 'best-time-visit-saudi-arabia',
    title: 'Best Time to Visit Saudi Arabia: A Seasonal Guide',
    excerpt: 'Plan your trip perfectly with our comprehensive guide to Saudi Arabia weather, events, and peak seasons.',
    category: 'Travel Planning',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20desert%20landscape%20in%20Saudi%20Arabia%20at%20golden%20hour%2C%20dramatic%20sand%20dunes%2C%20beautiful%20sky%20with%20warm%20colors%2C%20peaceful%20atmosphere%2C%20professional%20landscape%20photography%2C%20cinematic%20composition&width=800&height=500&seq=blog-saudi-seasons-005&orientation=landscape',
    author: 'Ahmed Hassan',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20middle%20eastern%20man%20in%20business%20attire%2C%20friendly%20smile%2C%20neutral%20background%2C%20high%20quality%20portrait%20photography&width=100&height=100&seq=author-ahmed-001&orientation=squarish',
    date: '5 Jan 2025',
    readTime: '6 min read',
    featured: false,
  },
  {
    id: 6,
    slug: 'cultural-etiquette-middle-east',
    title: 'Cultural Etiquette: Respecting Local Customs in the Middle East',
    excerpt: 'Understanding dress codes, greetings, and social norms to ensure a respectful and enriching travel experience.',
    category: 'Cultural Insights',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Middle%20Eastern%20hospitality%20scene%20with%20Arabic%20coffee%20service%2C%20ornate%20cups%2C%20dates%2C%20elegant%20setting%2C%20warm%20ambient%20lighting%2C%20cultural%20authenticity%2C%20professional%20photography&width=800&height=500&seq=blog-culture-006&orientation=landscape',
    author: 'Fatima Al-Rashid',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20elegant%20woman%20wearing%20hijab%2C%20warm%20smile%2C%20neutral%20background%2C%20high%20quality%20portrait%20photography&width=100&height=100&seq=author-fatima-001&orientation=squarish',
    date: '2 Jan 2025',
    readTime: '9 min read',
    featured: false,
  },
  {
    id: 7,
    slug: 'luxury-hotels-makkah-madinah',
    title: 'Top Luxury Hotels Near Haram in Makkah and Madinah',
    excerpt: 'Our curated selection of the finest accommodations for pilgrims seeking comfort and proximity to the holy sites.',
    category: 'Accommodation',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20hotel%20room%20with%20stunning%20view%20of%20Masjid%20al-Haram%20through%20large%20window%2C%20elegant%20interior%20design%2C%20premium%20furnishings%2C%20warm%20lighting%2C%20five%20star%20accommodation%2C%20professional%20interior%20photography&width=800&height=500&seq=blog-luxury-hotels-007&orientation=landscape',
    author: 'Omar Khalil',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Arab%20man%20with%20beard%2C%20friendly%20expression%2C%20neutral%20background%2C%20high%20quality%20portrait%20photography&width=100&height=100&seq=author-omar-001&orientation=squarish',
    date: '28 Dec 2024',
    readTime: '11 min read',
    featured: false,
  },
  {
    id: 8,
    slug: 'packing-guide-hajj-umrah',
    title: 'Essential Packing List for Hajj and Umrah',
    excerpt: 'A comprehensive checklist of everything you need to bring for a comfortable and prepared pilgrimage.',
    category: 'Spiritual Travel',
    image: 'https://readdy.ai/api/search-image?query=Neatly%20organized%20travel%20essentials%20for%20pilgrimage%20laid%20out%20on%20white%20surface%2C%20ihram%20garments%2C%20prayer%20items%2C%20travel%20accessories%2C%20minimalist%20flat%20lay%20photography%2C%20clean%20composition%2C%20soft%20lighting&width=800&height=500&seq=blog-packing-008&orientation=landscape',
    author: 'Sarah Thompson',
    authorImage: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20friendly%20British%20woman%2C%20warm%20smile%2C%20neutral%20background%2C%20high%20quality%20portrait%20photography&width=100&height=100&seq=author-sarah-001&orientation=squarish',
    date: '25 Dec 2024',
    readTime: '8 min read',
    featured: false,
  },
];

export const categories = [
  'All',
  'London Guide',
  'Spiritual Travel',
  'Destination Guide',
  'Family Travel',
  'Food & Culture',
  'Travel Planning',
  'Cultural Insights',
  'Accommodation',
];
